<template>
  <div class="col">
    <div class="col col-md-10 mb-5 mx-auto d-none d-lg-flex">
      <table class="info-financiera flex-grow-1">
        <thead>
          <tr>
            <th colspan="2" scope="col" class="text-center">
              <div>Estado de Situación ($M)</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row" style="width:50%">
              <div>
                Activo Corriente
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.activoCorriente)}}</span>
              </div>
            </td>
            <td style="width:50%">
              <div>
                Pasivo Corriente
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.pasivoCorriente)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <div>
                Activo no Corriente
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.activoNoCorriente)}}</span>
              </div>
            </td>
            <td>
              <div>
                Pasivo no Corriente
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.pasivoNoCorriente)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <div>
                Total Activos
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.totalActivos)}}</span>
              </div>
            </td>
            <td>
              <div>
                Patrimonio Total
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.patrimonioTotal)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">&nbsp;</td>
            <td>
              <div>
                Total Pasivos y Patrimonio
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.totalPasivoPatrimonio)}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col col-md-8 mb-5 mx-auto d-block d-md-none">
      <table class="info-financiera">
        <thead>
          <tr>
            <th colspan="2" scope="col" class="text-center">
              <div>Estado de situación</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row">
              <div>
                Activo corriente
                <span
                  class="float-right text-nowrap"
                >{{transformaconMonetaria(info.activoCorriente)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <div>
                Activo no corriente
                <span
                  class="float-right text-nowrap"
                >{{transformaconMonetaria(info.activoNoCorriente)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <div class="mb-3">
                Total activos
                <span
                  class="float-right text-nowrap"
                >{{transformaconMonetaria(info.totalActivos)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                Pasivo corriente
                <span
                  class="float-right text-nowrap"
                >{{transformaconMonetaria(info.pasivoCorriente)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                Pasivo no corriente
                <span
                  class="float-right text-nowrap"
                >{{transformaconMonetaria(info.pasivoNoCorriente)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                Patrimonio total
                <span
                  class="float-right text-nowrap"
                >{{transformaconMonetaria(info.patrimonioTotal)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div>
                Total pasivos y patrimonio
                <span
                  class="float-right text-nowrap"
                >{{transformaconMonetaria(info.totalPasivoPatrimonio)}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col col-md-6 mx-auto d-lg-flex">
      <table class="info-financiera flex-grow-1">
        <thead>
          <tr>
            <th colspan="2" scope="col" class="text-center">
              <div>Estado de Resultado ($M)</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td scope="row">
              <div>
                Ingresos de la Operación
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.ingresosOperacion)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <div>
                Costos y Gastos de la Operación
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.costosGastosOperacion)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <div>
                Otras Ganancias o Pérdidas
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.otrasGananciasPerdidas)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <div>
                Resultado Financiero
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.resultadoFinanciero)}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td scope="row">
              <div>
                Resultado del Ejercicio
                <span
                  class="float-lg-right text-nowrap"
                >{{transformaconMonetaria(info.resultadoEjercicio)}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import FormatoMonetario from "@/utils/FormatoMonetario.js";

export default {
  name: "InformacionFinanciera",
  props: {
    info: {
      type: Object
    }
  },
  methods: {
    transformaconMonetaria(value) {
      return FormatoMonetario.getMontoEnMoneda(value);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/fichaInstitucion/InformacionFinanciera.vue